import styled, { keyframes } from 'styled-components';
import { backgroundTheme, media } from '../../styles/style-utils';

export const StyledWrapper = styled.div`
  padding: 0 0 4rem 0;
  background: white;

  > section {
    padding: 1rem 2rem;
  }
`;

export const ContentWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${media.fromMedium`flex-direction: row;`}
`;

export const SpiceWrapper = styled.section`
  margin: 2rem 0 0;
`;

export const SideWrapper = styled.section`
  width: 100%;
  ${media.fromMedium`width: 35%;`}
`;
export const MarkdownWrapper = styled.section`
  width: 100%;
  padding-right: 0;
  ${media.fromMedium`
    width: 65%;
    padding-right: 4rem;
  `}
`;


export const HeaderSection = styled.section`
  padding: 8rem 1rem;
  margin: 5rem 0 4rem 0;
  position: relative;
`;

export const BackLinkWrap = styled.div`
  position: absolute;
  display: block;
  width: 100px;
  font-size: 2rem;
  line-height: 2rem;
  padding: 1rem;
  top: -5rem;
  left: 0;
  border-bottom: 1px solid black;

  > a {
    color: black;
  }
`;



// WEBPACK FOOTER //
// ./src/templates/NutrientTemplate/NutrientTemplateStyles.js